/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleInformationEquipmentReportData
 */
export interface VehicleInformationEquipmentReportData {
    /**
     * 
     * @type {string}
     * @memberof VehicleInformationEquipmentReportData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleInformationEquipmentReportData
     */
    vehicleInformationReportDataId?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleInformationEquipmentReportData
     */
    name?: string | null;
}

export function VehicleInformationEquipmentReportDataFromJSON(json: any): VehicleInformationEquipmentReportData {
    return VehicleInformationEquipmentReportDataFromJSONTyped(json, false);
}

export function VehicleInformationEquipmentReportDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleInformationEquipmentReportData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'vehicleInformationReportDataId': !exists(json, 'vehicleInformationReportDataId') ? undefined : json['vehicleInformationReportDataId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function VehicleInformationEquipmentReportDataToJSON(value?: VehicleInformationEquipmentReportData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'vehicleInformationReportDataId': value.vehicleInformationReportDataId,
        'name': value.name,
    };
}


